// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".treatment-action-button[data-v-1c6b578b]{margin-top:6px;margin-right:5px;margin-bottom:8px}.vertical-line[data-v-1c6b578b]{width:1px;height:20px;background-color:#d3d3d3;margin-top:12px}", ""]);
// Exports
module.exports = exports;
